import CryptoJS from 'crypto-js';

/**
 * aes数据加密
 * @param {String} word 待加密的字符串
 * @param {String} keyStr 解密的字符串
 * @returns 加密后的字符串
 */
export const aesEncrypt = function (word, keyStrs) { // word, keyStr第一个参数是加密的字段名字  第二个是key值（16位）
  const keyStr = keyStrs; // 密文（密钥）
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

/**
 * aes数据解密
 * @param {String} word 待解密的字符串
 * @param {String} keyStr 解密的密钥
 * @returns 解密后的字符串
 */
export const aesDecrypt = function (word, keyStr) {
  // console.log(word,keyStr);
  // keyStr = keyStr;
  var key = CryptoJS.enc.Utf8.parse(keyStr) // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}
/* export default {
    install(Vue) {
        // 加密

    },
} */